export class CriminalRecordStatuteBatchRow {
    id: number;
    chargeDescription: string;
    keywords: string;
    jurisdictionId: number;
    jurisdictionString: string;
    statuteId: number;
    statute: string;
    distinctStatuteString: string;
}

export class StatuteCrumbs{
    statuteId : number;
    mappedOffensesCount : number;
    indexx : number;
    hasMappings : boolean;
}

export class StatuteCategoryMapping { 
    statuteId: number;
    subCategoryId: number;
    crimeCategoryId: number;
    friendlyName: string;
}


export class CrimSubCategory {
    id: number;
    name: number;
    crimeCategoryId: number;
    friendlyName: string;
}